import { render } from "./simplebar.vue?vue&type=template&id=97d8e038"
import script from "./simplebar.vue?vue&type=script&lang=js"
export * from "./simplebar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__